import React from 'react';
import styles from './headerLayout.module.css';

const HeaderPart = () => {
   const scrollToForm = () => {
    document.getElementById('art-therapy-form')?.scrollIntoView({ 
      behavior: 'smooth' 
    });
  };

  return (
    <div className={styles.eventContainerHeader}>
      {/* Hero Section */}
      <div className={styles.eventHeroSection}>
        <div className={styles.heroContent}>
          <h1>Expressive Art Workshop 2.0 – An Evening of Colors & Connections & Conversations</h1>
          <div className={styles.eventDetails}>
           6th Dec 2025 | 3 To 5 PM | The Artist House, Surajpole, Udaipur
          </div>
          <br />
          <button className={styles.registerBtn} onClick={scrollToForm}>
            Register Now
          </button>
        </div>
      </div>
      </div>
  );
};

export default HeaderPart;